import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { exportDropdownListitems } from "../members/filterMember";
import { ReportExportBootstrap } from "./pdfExport";
import {
  setAllReportsData,
  setIsExpotred,
} from "../../../../redux/actions/reports/reportsAction";
import { addExtraColumnPerGymSettings } from "./utils";

export const ReportExportButton = ({ currentTab, title, exportAll,from,to,gymName,withExtraCols }) => {
  const [dropdownOpen, setDropDownOpen] = React.useState(false);
  const { reports, allReports } = useSelector(
    (state) => state.report
  );
  const [setAllReports, setAll] = useState(false);
  const [expotredReports, setExpotredReports] = useState(false);

  const [allPdf, setAllPdf] = useState(false);
  const [allExcel, setAllExcel] = useState(false);

  const [exportPdf, setExportPdf] = useState(false);
  const [exportExcel, setExportExcel] = useState(false);
  const {gym} = useSelector((state) => state.gym);
  const { commonLoading } = useSelector((state) => state.common);
  const[extraColsForExport,setExtraColsForExport]=useState({colsForExport:[],valuesForExport:{}})
  const dispatch = useDispatch();
  const toggle = () => {
    setDropDownOpen((prevState) => !prevState);
  };
  React.useEffect(() => {
    if (setAllReports) {
      exportAll();
      setAll(false);
    }
  }, [setAllReports]);

  React.useEffect(() => {
    if (expotredReports) {
      // exportAll();
      dispatch(setIsExpotred(true));
      setExpotredReports(false);
    }
  }, [expotredReports]);

  useEffect(()=>{
    if(withExtraCols){
      const settings =gym?.settings
      const {colsForExport,valuesForExport}=addExtraColumnPerGymSettings({settings})
      setExtraColsForExport({colsForExport,valuesForExport})
    }
    else setExtraColsForExport({colsForExport:[],valuesForExport:{}})

  },[withExtraCols,gym])  
  const handleClick = (click) => {
    const report = new ReportExportBootstrap(title, reports, currentTab,from,to,gymName,extraColsForExport);
    switch (click) {
      case "Pdf": {
        setAllPdf(false);
        setExpotredReports(true);
        setExportPdf(true);
        break;
      }
      case "Excel": {
        setAllExcel(false);
        setExpotredReports(true);
        setExportExcel(true);
        break;
      }
      case "Pdf (All)": {
        setAll(true);
        setAllPdf(true);
        break;
      }
      case "Excel (All)": {
        setAll(true);
        setAllExcel(true);
        break;
      }
      default:
        return;
    }
  };
  React.useEffect(() => {
    // This useEffect will be triggered when setAll is updated to true
    if (allReports.length) {
      const report = new ReportExportBootstrap(title, allReports, currentTab,from,to,gymName,extraColsForExport);
      if (allPdf || exportPdf) {
        report.downloadPDF();
      }
      if (allExcel || exportExcel) {
        if (title == "accountingEntry") {
          report.exportToExcelMultipleTabs();
        } else {
          report.exportToExcel();
        }
      }
      dispatch(setAllReportsData([]));
      dispatch(setIsExpotred(false));
      setExportPdf(false);
      setExportExcel(false);
      setAllExcel(false);
      setAllPdf(false);
    }
  }, [allReports]);
  return (
    <ButtonDropdown
      isOpen={dropdownOpen}
      toggle={!commonLoading ? toggle : undefined} // prevent toggling while loading
      disabled={commonLoading}
    >
      <DropdownToggle
        className="report-top-button-width d-flex align-items-center justify-content-center gap-2"
        caret
        // color={commonLoading ? "secondary" : "primary"}
      >
        {commonLoading ? (
          <>
            <Spinner size="sm" color="light" /> Loading...
          </>
        ) : (
          "Export Data"
        )}
      </DropdownToggle>

      <DropdownMenu className="custom-dropdown-block">
        <div className="sub-title px-3 pt-2 pb-1 text-muted fw-bold">
          Export To
        </div>
        {exportDropdownListitems.map((items, idx) => (
          <DropdownItem
            key={idx}
            onClick={() => handleClick(items.innertitle)}
            disabled={commonLoading}
            className="d-flex align-items-center gap-2"
          >
            <img
              alt=""
              src={items.svg}
              className="img-fluid"
              style={{ width: 18, height: 18 }}
            />
            {items.innertitle}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </ButtonDropdown>
  );
};
